import { Text } from '@modusign/design-system';
import { format, isThisYear, isToday, isValid } from 'date-fns';
import ko from 'date-fns/locale/ko';
import { useMemo } from 'react';

type TextProps = Parameters<typeof Text>[0];

interface FormatTimeTextProps extends TextProps {
  dateString: string;
}

function FormatTimeText({ dateString, ...props }: FormatTimeTextProps) {
  const dateObj = useMemo(() => new Date(dateString), [dateString]);

  const formatString = useMemo(() => {
    if (isToday(dateObj)) {
      return 'a h:mm';
    }
    if (isThisYear(dateObj)) {
      return 'MM-dd HH:mm';
    }
    return 'yy-MM-dd HH:mm';
  }, [dateObj]);

  if (!isValid(new Date(dateString))) return null;

  return (
    <Text color="textNeutralLight" fontSize="sm" lineHeight="1.2" whiteSpace="nowrap" {...props}>
      {format(dateObj, formatString, { locale: ko })}
    </Text>
  );
}

export default FormatTimeText;
